import { Alert } from '@c2fo/liquidity';

const SomethingsWrong = () => {
  return (
    <div className="flex items-center justify-center min-h-screen p-4">
      <Alert
        type="error"
        variant="standard"
        full
        title="Something went wrong"
        description="An unexpected error occurred. Please try refreshing the page."
        action={{
          text: 'Reload Page',
          onClick: () => window.location.reload(),
        }}
      />
    </div>
  );
};

export default SomethingsWrong;
